import { Box, Grid, Typography } from "@common-ui/ui";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { ClientPlaceProfileImage } from "./ClientPlaceProfileImage";

export const ClientProfile = ({ clientProfile }) => {
  const city =
    clientProfile?.street_address && clientProfile?.street_address?.city !== ""
      ? clientProfile?.street_address?.city
      : "--";
  const stateOrProvince =
    clientProfile?.street_address &&
    clientProfile?.street_address?.state_or_province !== ""
      ? clientProfile?.street_address?.state_or_province
      : "--";
  const website = clientProfile?.website !== "" ? clientProfile?.website : "--";
  const email =
    clientProfile?.support_email !== "" || clientProfile?.email !== ""
      ? clientProfile?.support_email || clientProfile?.email
      : "--";
  const phone =
    clientProfile?.support_phone !== "" || clientProfile?.phone !== ""
      ? clientProfile?.support_phone || clientProfile?.phone
      : "--";

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <ClientPlaceProfileImage data={clientProfile} />
      </Grid>
      <Grid item md={10} xs={8}>
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="stretch"
        >
          <Grid sx={{ marginLeft: "1rem" }} item>
            <Typography
              sx={{ mt: 1, position: "relative" }}
              variant="h6"
              fontWeight="700"
            >
              {clientProfile?.name}
            </Typography>
            <Box>
              <Typography fontWeight="700" fontSize="0.7rem">
                <LocationOnIcon
                  fontSize="small"
                  style={{ verticalAlign: "middle" }}
                  color="disabled"
                />{" "}
                {`${city}, ${stateOrProvince}`}
              </Typography>
            </Box>
          </Grid>
          <Grid sx={{ marginLeft: "1rem" }} item xs={12}>
            <Typography fontWeight="700" fontSize="0.7rem">
              <span style={{ display: "inline-flex", marginRight: 2 }}>
                <LanguageIcon
                  fontSize="small"
                  style={{ verticalAlign: "middle", marginRight: 5 }}
                  color="disabled"
                />
                {website}
              </span>
              <span style={{ display: "inline-flex", marginRight: 2 }}>
                <EmailIcon
                  fontSize="small"
                  style={{ verticalAlign: "middle", marginRight: 5 }}
                  color="disabled"
                />
                {email}
              </span>
              <span style={{ display: "inline-flex", marginRight: 2 }}>
                <PhoneIphoneIcon
                  fontSize="small"
                  style={{ verticalAlign: "middle" }}
                  color="disabled"
                />
                {phone}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
